import React, { useState } from 'react';

export interface FaqItem {
  question: string;
  answer: string;
}

interface FaqAccordionProps {
  items: FaqItem[];
}

const Chevron: React.FC<{ open: boolean }> = ({ open }) => (
  <span
    className="faq-opener"
    style={{
      display: 'inline-flex',
      transition: 'transform 0.3s',
      transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
    }}
  >
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.41 9.08008L12 13.6701L16.59 9.08008L18 10.5001L12 16.5001L6 10.5001L7.41 9.08008Z" fill="#1A1A1A"/>
</svg>

  </span>
);

export const FaqAccordion: React.FC<FaqAccordionProps> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const handleToggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="faqs-list">
      {items.map((item, idx) => (
        <div className="faq-card" key={idx}>
          <button
            className="faq-toggle"
            onClick={() => handleToggle(idx)}
            aria-expanded={openIndex === idx}
            aria-controls={`faq-answer-${idx}`}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              width: '100%',
              textAlign: 'left',
              gap: '12px',
            }}
          >
            <Chevron open={openIndex === idx} />
            <p className="subtitles large color black" style={{ margin: 0 }}>
              <strong>{item.question}</strong>
            </p>
          </button>
          <div
            id={`faq-answer-${idx}`}
            className="faq-answer"
            style={{
              maxHeight: openIndex === idx ? 200 : 0,
              opacity: openIndex === idx ? 1 : 0,
              overflow: 'hidden',
              transition: 'max-height 0.3s cubic-bezier(0.4,0,0.2,1), opacity 0.3s',
              marginTop: openIndex === idx ? 12 : 0,
            }}
          >
            <p className="paragraphs medium color dark-charcoal" style={{ margin: 0 }}>
              {item.answer}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}; 